import Swiper, { Autoplay, Pagination } from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';

const rootSelector = '.home-hero-swiper-wr';
const initializedWrappers = new WeakSet();

const getWrappers = (scope) => {
  const wrappers = new Set();

  if (scope?.matches?.(rootSelector)) {
    wrappers.add(scope);
  }

  scope?.querySelectorAll?.(rootSelector).forEach((wrapper) => wrappers.add(wrapper));

  return wrappers;
};

const initHomeHeroSwiper = (scope = document) => {
  getWrappers(scope).forEach((wrapper) => {
    if (initializedWrappers.has(wrapper)) {
      return;
    }

    const swiperEl = wrapper.querySelector('.swiper');
    const paginationEl = wrapper.parentElement?.querySelector('.home-hero-sec__pagination');
    const slidesCount = wrapper.querySelectorAll('.swiper-slide').length;

    if (!swiperEl || swiperEl.swiper || slidesCount < 2) {
      return;
    }

    initializedWrappers.add(wrapper);

    const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;
    const swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Pagination],
      observer: true,
      observeParents: true,
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 900,
      loop: true,
      threshold: 10,
      watchOverflow: true,
      preventInteractionOnTransition: true,
      autoplay: reducedMotion ? false : {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      pagination: paginationEl ? {
        el: paginationEl,
        clickable: true,
        renderBullet: (index, className) => (
          '<button class="' + className + '" type="button" aria-label="Show hero image ' + (index + 1) + '"></button>'
        ),
      } : undefined,
    });

    if (!reducedMotion) {
      swiperObserver(swiper);
    }
  });
};

initHomeHeroSwiper();
window.initHomeHeroSwiper = initHomeHeroSwiper;
